var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{directives:[{name:"attach",rawName:"v-attach:attach",arg:"attach"}],attrs:{"d":_vm.path,"stroke-width":"1.5","stroke-linecap":"round","fill":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }